import Search from './search';
import env from '../../../../shared/env';

/**
 * Get Input value from the Header search field
 */
function getInputSearchValue() {
  // hack to catch input value from search input field prior header component render
  const el = document.querySelector('#header #PageForm input');
  if (el) {
    window.INPUTSEARCHVALUE = el.value;
    el.addEventListener('change', (event) => {
      window.INPUTSEARCHVALUE = event.target.value;
    });
  }
}

if (!env.isNode()) {
  getInputSearchValue();
}

export { Search as default };
